import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import jwt_decode from "jwt-decode";
import { attemptTokenRefresh, clearSessionAndRedirect } from "utils/tokenRefresh";

export { attemptTokenRefresh };

const withReauth = (baseQuery) => async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error?.status === 401) {
    const refreshed = await attemptTokenRefresh();
    if (refreshed) {
      api.dispatch({ type: "shared/setUserToken", payload: jwt_decode(localStorage.getItem("token")) });
      window.location.reload();
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch({ type: "shared/showSessionTimeout" });
      clearSessionAndRedirect();
    }
  }

  return result;
};

const mainBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers, { getState }) => {
    const rawToken = localStorage.getItem("token") || null;
    headers.append("ClientTimeZone", new Date().getTimezoneOffset());
    if (rawToken !== null) {
      headers.append("Authorization", `Bearer ${rawToken}`);
    } else {
      headers.append("Access-Control-Allow-Origin", "*");
    }
    if (getState().sharedState.previewStagingEnabled) {
      headers.append("X-Preview-Staging", "true");
    }
    return headers;
  },
});

const previewBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_PREVIEW_API_URL,
  prepareHeaders: (headers) => {
    const rawToken = localStorage.getItem("token") || null;
    if (rawToken !== null) {
      headers.append("Authorization", `Bearer ${rawToken}`);
    } else {
      headers.append("Access-Control-Allow-Origin", "*");
    }
    return headers;
  },
});

const nonUserBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers) => {
    headers.append("ClientTimeZone", new Date().getTimezoneOffset());
    headers.append("Access-Control-Allow-Origin", "*");
    return headers;
  },
});

export const emptySplitApi = createApi({
    reducerPath: "grantAdvanceApi",
    baseQuery: withReauth(mainBaseQuery),
    tagTypes: [
        "ProjectFundersProfileId",
        "SavedSearch",
        "SavedHistory",
        "FoundationTimeline",
        "LetterHead",
        "OrganizationInfo",
        "FunderQualifications",
        "Sectors",
        "GrantTypes",
        "DocumentStepReview",
        "FavoriteFundersQueue",
        "ProjectFundersQueue",
    ],
    endpoints: () => ({}),
});

export const previewSplitApi = createApi({
  reducerPath: "grantAdvancePreviewApi",
  baseQuery: withReauth(previewBaseQuery),
  endpoints: () => ({}),
});

export const nonUserApi = createApi({
  reducerPath: "grantAdvanceNonUserApi",
  baseQuery: withReauth(nonUserBaseQuery),
  endpoints: () => ({}),
});
